
import { Unit } from '@/store/unit/types';
import { Weather } from '@/store/weather/types';
import { Options, mixins } from 'vue-class-component';
import { mapGetters, mapActions } from 'vuex';
import CalculateTemperature from '../mixins/CalculateTemperature';
import GetWeatherImage from '../mixins/GetWeatherImage';
import BaseSpinner from './UI/BaseSpinner.vue';

@Options({
  emits: ['on-search'],
  computed: {
    ...mapGetters(['currentWeather', 'unit', 'isLoading']),
  },
  methods: {
    ...mapActions(['getPlaceBasedOnCoordinates']),
  },
  components: { BaseSpinner },
})
export default class extends mixins(CalculateTemperature, GetWeatherImage) {
  unit!: Unit;

  currentWeather!: Weather;

  isLoading!: boolean;

  getPlaceBasedOnCoordinates!: (payload: {
    latitude: number;
    longitude: number;
  }) => void;

  get formattedDate(): string {
    return new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      month: 'short',
      weekday: 'short',
    }).format(this.currentWeather.currentDate);
  }

  get weatherStateName(): string {
    return this.currentWeather.weatherStateName;
  }

  get currentTemperature(): number {
    return Math.round(
      this.calculateTemperature(this.currentWeather.currentTemperature),
    );
  }

  get weatherImage(): string {
    return this.getWeatherImage(this.currentWeather.weatherStateName);
  }

  get formattedUnit(): string {
    return `°${this.unit}`;
  }

  handleSearch(e: Event) {
    this.$emit('on-search', e);
  }

  // eslint-disable-next-line class-methods-use-this
  handleGetCurrentLocation() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.getPlaceBasedOnCoordinates(position.coords);
    });
  }
}
